import React, { useState } from 'react';
import { Box, TextField, Button } from '@mui/material';
import {
  collection,
  addDoc,
  setDoc,
  doc,
  serverTimestamp
} from 'firebase/firestore';

import { db } from '../firebase';
import { useUser } from '../UserContext';

function SendMessage({ conversationId, recipientId, recipientName, recipientAwayStatus }) {
  const [message, setMessage] = useState('');
  const { user } = useUser();

  const handleSendMessage = async (e) => {
    e.preventDefault();

    if (!user) {
      console.error('Error: No user is logged in.');
      return;
    }

    if (message.trim() === '') return;

    try {
      await addDoc(collection(db, `conversations/${conversationId}/messages`), {
        senderId: user.uid,
        recipientId,
        message,
        timestamp: serverTimestamp(),
        read: false,
        movedToBin: false
      });

      await setDoc(
        doc(db, 'conversations', conversationId),
        {
          participants: [user.uid, recipientId],
          lastMessage: message,
          lastUpdated: serverTimestamp()
        },
        { merge: true }
      );

      setMessage(''); // Clear input after sending
    } catch (error) {
      console.error('Error sending message:', error);
    }
  };

  return (
    <Box
      component="form"
      onSubmit={handleSendMessage}
      display="flex"
      alignItems="center"
      p={1}
      sx={{
        width: '100%',
        maxWidth: '100vw',
        boxSizing: 'border-box',
        bgcolor: '#fff',
        position: 'sticky',
        bottom: 0
      }}
    >
      <TextField
        variant="outlined"
        fullWidth
        multiline
        placeholder={`Message ${recipientName}${recipientAwayStatus ? ' (Away)' : ''}`}
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        sx={{ marginRight: 2 }}
      />
      <Button
        variant="contained"
        color="primary"
        type="submit"
        sx={{
          flexShrink: 0,
          minWidth: '75px'
        }}
      >
        Send
      </Button>
    </Box>
  );
}

export default SendMessage;
